import script from "./index-two.vue?vue&type=script&setup=true&lang=js"
export * from "./index-two.vue?vue&type=script&setup=true&lang=js"

import "./index-two.vue?vue&type=style&index=0&id=e907525a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e907525a"]])

export default __exports__